<template>
  <div class="chart-wrap">
    <div class="chart-subtitle">24小时类目价格趋势</div>
    <ChartBox :option="option" />
  </div>
</template>

<script setup>
import * as echarts from "echarts";
import { computed } from "vue";
import ChartBox from "@/components/xiaofeiTradeData/ChartBox.vue";

const trendTimes = createLast24HourTimes();

function padTime(value) {
  return String(value).padStart(2, "0");
}

function formatTrendTime(date) {
  const hour = padTime(date.getHours());
  const minute = padTime(date.getMinutes());
  return `${hour}:${minute}`;
}

function createLast24HourTimes() {
  const now = new Date();
  const start = new Date(now);
  start.setHours(now.getHours() - 24);

  return Array.from({ length: 13 }, (_, index) => {
    const date = new Date(start);
    const baseMinutes = index * 120;
    const jitterMinutes = index === 0 || index === 12 ? 0 : Math.floor(Math.random() * 57) - 28;
    date.setMinutes(start.getMinutes() + baseMinutes + jitterMinutes);

    if (index === 12) {
      date.setTime(now.getTime());
    }

    return formatTrendTime(date);
  });
}

const option = computed(() => ({
  color: ["#ff9b32", "#37b8ff", "#2ad7b8", "#8c5cf8", "#ff6676"],
  grid: { top: 100, left: 70, right: 50, bottom: 48 },
  legend: {
    top: 30,
    right: 16,
    icon: "rect",
    itemWidth: 22,
    itemHeight: 4,
    textStyle: { color: "#d8edff", fontSize: 18 },
    data: ["上蔡八子特产", "邵店黄姜", "朱里红薯", "羊肚菌"],
  },
  tooltip: { trigger: "axis", textStyle: { fontSize: 24 } },
  xAxis: {
    type: "category",
    boundaryGap: false,
    data: trendTimes,
    axisTick: { show: false },
    axisLine: { lineStyle: { color: "rgba(104, 172, 232, .48)" } },
    axisLabel: { color: "#cde6ff", fontSize: 16, margin: 16, lineHeight: 22 },
  },
  yAxis: {
    type: "value",
    min: 0,
    max: 150,
    axisLabel: { color: "#cde6ff", fontSize: 16 },
    splitLine: { lineStyle: { color: "rgba(116, 173, 225, .18)" } },
  },
  series: [
    makeLine("上蔡八子特产", [43.5, 43.2, 44.1, 44.8, 45.6, 45.2, 46.1, 47.3, 46.5, 47.8, 48.2, 47.6, 48.8]),
    makeLine("邵店黄姜", [34.2, 34.8, 35.6, 36.4, 37.2, 36.8, 38.6, 39.1, 38.4, 39.9, 40.6, 39.8, 40.8]),
    makeLine("朱里红薯", [24.8, 25.2, 25.9, 26.6, 27.4, 27.1, 28.2, 29.1, 28.5, 29.9, 30.4, 29.7, 30.8]),
    makeLine("羊肚菌", [121, 120, 124, 126, 128, 127, 130, 132, 129, 134, 136, 133, 138]),
  ],
}));

function makeLine(name, data) {
  return {
    name,
    type: "line",
    smooth: true,
    symbol: "circle",
    symbolSize: 7,
    lineStyle: { width: 3 },
    areaStyle: {
      color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
        { offset: 0, color: "rgba(48, 160, 255, .18)" },
        { offset: 1, color: "rgba(48, 160, 255, 0)" },
      ]),
    },
    data,
  };
}
</script>

<style lang="less" scoped>
.chart-wrap {
  height: 100%;
  position: relative;
}

.chart-subtitle {
  position: absolute;
  left: 28px;
  top: 30px;
  z-index: 2;
  color: #d8edff;
  font-size: 26px;
  font-weight: bold;
}
</style>
